var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a4f597e51952ed0ccfd2a164692aa8d07134bf91"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["flip2store@hardpixel"]={id:"a4f597e51952ed0ccfd2a164692aa8d07134bf91"};
      